import {defineField} from 'sanity'
import {dotcomDocument} from './dotcom.document'
export default defineField({
  title: 'silversea.com Destination',
  name: 'dotcomDestination',
  ...dotcomDocument('destination'),
  weak: false,
})
